import { Link } from 'react-router-dom';

export function PrivacyPage() {
  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <h1 className="text-3xl font-bold text-gray-900 mb-2">Política de Privacidad</h1>
      <p className="text-sm text-gray-500 mb-8">Última actualización: agosto 2026</p>

      <div className="prose prose-gray max-w-none space-y-6 text-gray-700 text-sm leading-relaxed">
        <section>
          <h2 className="text-lg font-semibold text-gray-900 mb-2">1. Responsable del Tratamiento</h2>
          <p>
            OVIEDOTECH S.A.S., identificada con NIT 901.964.524-2, con domicilio en Cra. 46 #45-88, Cali, 
            Valle del Cauca, Colombia, es responsable del tratamiento de los datos personales recopilados 
            a través de la plataforma DonaApp.
          </p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-gray-900 mb-2">2. Datos que Recopilamos</h2>
          <p>Dependiendo de cómo interactúe con la Plataforma, podemos recopilar:</p>
          <ul className="list-disc pl-5 space-y-1 mt-2">
            <li><strong>Organizadores (usuarios registrados):</strong> nombre completo, correo electrónico, número de teléfono, imagen de perfil (opcional).</li>
            <li><strong>Donantes (sin registro):</strong> nombre, correo electrónico y número de teléfono al momento de registrar un compromiso de donación.</li>
            <li><strong>Datos de uso:</strong> información técnica como dirección IP, tipo de navegador y páginas visitadas.</li>
          </ul>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-gray-900 mb-2">3. Finalidad del Tratamiento</h2>
          <p>Sus datos personales son utilizados para:</p>
          <ul className="list-disc pl-5 space-y-1 mt-2">
            <li>Gestionar su cuenta y autenticación en la plataforma.</li>
            <li>Facilitar la coordinación entre donantes y organizadores de campañas.</li>
            <li>Enviar notificaciones sobre el estado de campañas y compromisos.</li>
            <li>Mejorar la experiencia de usuario y funcionalidad de la plataforma.</li>
            <li>Cumplir con obligaciones legales cuando sea requerido.</li>
          </ul>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-gray-900 mb-2">4. Protección de Datos del Donante</h2>
          <p>
            La información de contacto de los donantes (teléfono, email) es visible únicamente para el 
            organizador de la campaña a la que se realizó el compromiso. Esta información NO se muestra 
            públicamente en la plataforma ni se comparte con terceros.
          </p>
          <p>
            Los donantes pueden optar por aparecer como "Donante Anónimo" para ocultar su nombre en 
            la lista pública de compromisos de una campaña.
          </p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-gray-900 mb-2">5. Compartición de Datos</h2>
          <p>No vendemos ni compartimos datos personales con terceros para fines comerciales. Los datos solo se comparten:</p>
          <ul className="list-disc pl-5 space-y-1 mt-2">
            <li>Entre donante y organizador para coordinar entregas.</li>
            <li>Con proveedores de servicios esenciales (hosting, email) bajo acuerdos de confidencialidad.</li>
            <li>Cuando sea requerido por autoridad judicial competente.</li>
          </ul>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-gray-900 mb-2">6. Seguridad</h2>
          <p>
            Implementamos medidas técnicas y organizativas para proteger sus datos: cifrado en tránsito (HTTPS), 
            almacenamiento seguro de contraseñas (hash), control de acceso basado en roles, y monitoreo de actividad sospechosa.
          </p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-gray-900 mb-2">7. Derechos del Titular</h2>
          <p>De acuerdo con la normativa aplicable, usted tiene derecho a:</p>
          <ul className="list-disc pl-5 space-y-1 mt-2">
            <li>Conocer, actualizar y rectificar sus datos personales.</li>
            <li>Solicitar prueba de la autorización otorgada.</li>
            <li>Revocar la autorización y/o solicitar la supresión de sus datos.</li>
            <li>Presentar quejas ante la autoridad competente.</li>
          </ul>
          <p className="mt-2">
            Para ejercer estos derechos, contacte a{' '}
            <a href="mailto:contacto@donaapp.co" className="text-indigo-600 hover:underline">contacto@donaapp.co</a>.
          </p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-gray-900 mb-2">8. Retención de Datos</h2>
          <p>
            Los datos personales se conservan mientras la cuenta esté activa o mientras sea necesario para 
            cumplir con las finalidades descritas. Los usuarios pueden solicitar la eliminación de su cuenta 
            en cualquier momento.
          </p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-gray-900 mb-2">9. Modificaciones</h2>
          <p>
            Esta política puede ser actualizada periódicamente. Notificaremos cambios significativos 
            a través de la plataforma. La fecha de última actualización se indica al inicio de este documento.
          </p>
        </section>
      </div>

      <div className="mt-10 pt-6 border-t border-gray-200">
        <Link to="/" className="text-sm text-indigo-600 hover:underline">← Volver al inicio</Link>
      </div>
    </div>
  );
}
